var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3RcBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 142,
    viewBox: "0 0 80 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7585 36.1906C79.6976 36.0687 78.9665 35.0025 78.8751 34.8502C76.3161 13.3731 56.8497 -1.98066 35.3726 0.54784C17.399 2.71078 3.23325 16.8765 1.10078 34.8502C1.00938 34.972 0.27825 36.0992 0.217323 36.221C0.156395 36.3429 -0.239636 39.1456 0.217323 42.2529H0.917992C1.00938 43.6238 1.19217 45.0251 1.43588 46.3655V46.8225L1.55773 47.0357C3.90345 58.7948 11.4585 68.8479 22.1513 74.3314V78.0175C18.7698 79.6625 16.7287 81.795 16.7287 84.1103V94.011H16.7592C17.1857 97.7581 22.9129 100.926 30.9554 102.297L30.9554 141.5H49.1423L49.1423 102.206C56.8497 100.804 62.3332 97.6972 62.7597 94.0415H62.7901V93.5845V84.1407C62.7901 81.8255 60.7491 79.693 57.3676 78.048V74.636C69.8578 68.4823 78.1439 56.1444 79.1188 42.2834H79.8195C80.2155 39.1151 79.8499 36.3429 79.7585 36.1906Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5137 19.5274C31.6263 18.7049 35.7998 18.3088 39.9734 18.3088C55.2053 18.3088 68.579 23.5182 76.0122 31.2864C71.4731 11.4545 51.7325 -0.94434 31.9309 3.59478C31.0779 3.77756 30.225 4.02127 29.372 4.26498C28.4581 9.32199 27.8488 14.4095 27.5137 19.5274Z",
    fill: "#49A942"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6066 135.483L42.7734 137.25V90.3867L45.6066 91.3311V135.483Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9711 21.1426C35.7366 21.1426 31.5021 21.5691 27.359 22.4221C26.567 43.4726 31.4716 58.3694 33.8783 64.2794C35.7975 64.0053 37.7472 63.8834 39.6969 63.8834C49.4149 63.8834 57.2745 67.1126 57.2745 71.1033V72.0173C69.3382 65.6503 76.9238 53.1297 76.8933 39.4818C76.8933 38.5984 76.8628 37.7149 76.8019 36.8619C71.1965 27.6619 56.8176 21.1426 39.9711 21.1426Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7656 71.9855C45.8226 72.1073 50.2399 72.8385 53.8651 74.118V71.1325C50.2094 69.9749 45.9445 69.3047 41.1312 69.1523L40.7656 71.9855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8617 84.1712C55.0842 82.0997 49.0523 80.1804 39.6695 80.0586L39.2734 82.8613C49.6007 82.8917 55.5412 85.2679 58.8313 87.4309L58.8617 84.1712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3RcBrand);
export default __webpack_public_path__ + "static/media/3rc-brand.2535efea5d67d97d07e77f304f602529.svg";
export { ForwardRef as ReactComponent };